<template>
  <div>
    <div class="mymsg_top_bar">
      <span class="mymsg_tip mymsg_tip_noac" @click="goTome">个人中心</span>
      <i class="el-icon-arrow-right"></i>
      <span class="mymsg_tip mymsg_tip_noac" @click="friends">我的好友</span>
      <i class="el-icon-arrow-right"></i>
      <span class="mymsg_tip">我的团队</span>
    </div>
    <div class="mymsg_con">
      <div v-if="hasGroups">
        <el-row>
          <el-col :span="12">
            <!-- <div class="mymsg_item" v-for="item in friList" @click="tochat(item)"> -->
            <div
              class="mymsg_item"
              v-for="item in $store.state.msgContent.group"
              @click="tochat(item)"
            >
              <el-badge
                v-if="item.unreadMessages > 0"
                :value="item.unreadMessages"
                class="item"
              >
                <img
                  v-if="item.friendAvatar"
                  class="mymsg_fri_img"
                  :src="item.friendAvatar"
                />
                <img v-else class="mymsg_fri_img" src="../assets/face.jpg" />
              </el-badge>
              <div class="mymsg_item_right">
                <span class="mymsg_friend_name">{{ item.groupName }}</span>
                <span class="mymsg_friend_msg">{{ item.msg }}</span>
              </div>
            </div>
          </el-col>

          <el-col
            :span="12"
            v-if="null != $store.state.msgContent.tempGroupInfo"
            style="
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            "
          >
            <div>
              <div class="magBoxTop">
                <div
                  style="
                    font-size: 32px;
                    font-weight: bold;
                    margin-bottom: 10px;
                  "
                >
                  {{ $store.state.msgContent.tempGroupInfo.groupName }}
                </div>

                <div
                  v-if="
                    undefined ==
                    $store.state.msgContent[
                      'g' + $store.state.msgContent.tempGroupInfo.groupId
                    ]
                  "
                >
                  <div v-if="$store.state.msgContent.tempGroupInfo.type == 0">
                    给好友发条消息吧
                  </div>
                  <div v-else>给朋友们发条消息吧</div>
                </div>
                <div
                  v-else
                  @click="moreHistory()"
                  style="
                    text-align: center;
                    font-size: 15px;
                    color: rgb(38, 131, 190);
                    margin-bottom: 8px;
                  "
                >
                  加载更多
                </div>
              </div>
              <div
                id="magBox"
                class="magBox"
                :style="magBoxHeight ? { height: magBoxHeight + 'px' } : {}"
              >
                <!-- <div v-if="$store.state.msgContent.tempGroupInfo.type == 1"
              v-for="msg in $store.state.msgContent['group' + $store.state.msgContent.tempGroupInfo.friendId]">
              </div> -->
                <div
                  v-for="msg in $store.state.msgContent[
                    'g' + $store.state.msgContent.tempGroupInfo.groupId
                  ]"
                  class="wrapper"
                >
                  <!-- {{ msg }} -->
                  <div style="margin-bottom: 10px">
                    <!-- {{ msg }} -->
                    <div
                      style="color: grey; font-size: small; text-align: center"
                    >
                      {{ msg.createTime }}
                    </div>
                    <div
                      v-if="my.id == msg.sendUserId"
                      style="
                        background-color: lightblue;
                        border-radius: 10px;
                        width: 70%;
                        margin-left: auto;
                      "
                    >
                      <span style="margin: 0 20px; font-size: 20px">
                        <ChatMsgItem :msg="msg" />
                        <!-- {{ msg.msg }} -->
                      </span>
                    </div>
                    <!-- friend msg -->
                    <div
                      v-else
                      style="
                        background-color: lightgray;
                        border-radius: 10px;
                        width: 70%;
                      "
                    >
                      <div class="mymsg_item">
                        <img
                          v-if="msg.friendAvatar"
                          class="mymsg_fri_img"
                          :src="msg.friendAvatar"
                        />
                        <img
                          v-else
                          class="mymsg_fri_img"
                          src="../assets/face.jpg"
                        />
                        <div class="mymsg_item_right">
                          <span class="mymsg_friend_name">{{
                            msg.userName
                          }}</span>
                          <span class="mymsg_friend_msg">
                            <ChatMsgItem :msg="msg" />
                            <!-- {{ msg.msg }} -->
                          </span>
                        </div>
                      </div>

                      <!-- <span style="margin: 0 20px; font-size: 20px;">{{ msg.msg }}</span> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <mychat type="group"></mychat>
          </el-col>
        </el-row>
      </div>
      <el-empty description="您还没有添加过团队" v-else />
    </div>
  </div>
</template>

<script>
// import InfiniteLoading from 'vue-infinite-loading';
import {
  getUserTmpChatMsgs,
  getTmpChatList,
  getTmpGroupList,
  getMessageFromLast,
  getGroupMessageFromLast,
  setMessageReaded,
  setGroupMessageReaded,
} from "@/api/chat";
import { mapState, mapMutations } from "vuex";
import mychat from "./mychat.vue";
import { getMoreHistory, getMoreGroupHistory } from "../api/ws";
import CreateGroupDialog from "./CreateGroupDialog";
import ChatMsgItem from "./ChatMsgItem.vue";

export default {
  name: "mymsg",
  data() {
    return {
      tempFriend: null,
      friendId: null,
      // friList: [1, 2, 3],
      messageList: null,
      magBoxHeight: null,
      groupBoxHeight: null,
    };
  },
  components: {
    mychat,
    CreateGroupDialog,
    ChatMsgItem,
    // InfiniteLoading,
  },
  computed: {
    ...mapState({
      my: (state) => state.user,
    }),
    hasGroups() {
      return this.$store.state.msgContent.group.length !== 0;
    },
  },
  created() {
    /*  if (this.$store.state.msgContent.group.length == 0) {
      this.getChatList();
    } */
    this.calMagBoxHeight();
  },
  mounted() {
    this.getChatList();
    let friendInfo = this.$store.state.msgContent.tempGroupInfo;
    console.log("mounted", friendInfo);
    if (friendInfo) {
      // 此处friendInfo 格式与之前不一致，需要修正【可能不能从这里修正】
      let nFriendInfo = {
        groupId: friendInfo.groupId,
        groupName: friendInfo.groupName,
        friendAvatar: friendInfo.imageUrl,
        msg: null,
        unreadMessages: 0,
      };
      console.log("==tochat mounted ==", nFriendInfo);
      // 打开与该好友的聊天窗口
      this.tochat(friendInfo);
    }
  },
  methods: {
    ...mapMutations(["initGroupMsg"]),
    calMagBoxHeight() {
      let magBoxTop = document.getElementsByClassName("magBoxTop");
      if (magBoxTop && magBoxTop.length == 1) {
        let mainRight = document.getElementsByClassName("main_right");
        let mymsgTopBar = document.getElementsByClassName("mymsg_top_bar");
        let mychatSendMsgCon = document.getElementsByClassName(
          "mychat_send_msg_con"
        );
        // main_right 的高度- 上下padding 共40 - mymsg_top_bar - 上margin 30
        let chatHeight =
          mainRight[0].clientHeight - 40 - mymsgTopBar[0].clientHeight - 30;
        this.groupBoxHeight = chatHeight;
        // - 文本输入框的高度
        let historyHeight = chatHeight - mychatSendMsgCon[0].clientHeight;
        // - 好友名 和 加载信息的高度 - 随机数(border 等)
        this.magBoxHeight = historyHeight - magBoxTop[0].clientHeight - 20;
      }
    },
    scrollToBottom() {
      var div = document.getElementById("magBox");
      div.scrollTop = div.scrollHeight;
    },
    moreHistory() {
      var that = this;
      getMoreGroupHistory((errMsg) => {
        that.$message.error(errMsg);
      });
    },
    friends() {
      var that = this;

      that.$router.push({
        name: "friends",
        params: {
          refresh: true,
        },
      });
    },
    goTome() {
      this.$router.push({
        name: "me",
      });
    },
    formatToChat(item) {
      let friendInfo = {
        groupId: item.groupId,
        groupName: item.groupName,
        msg: item.msg,
        unreadMessages: item.unreadMessages,
        friendAvatar: item.friendAvatar,
      };

      console.log("==tochat format==", friendInfo);
      this.tochat(friendInfo);
    },
    tochat(friendInfo) {
      let { groupId } = friendInfo;
      // this.tempFriend = friend
      // 将该好友id存入缓存
      // this.$store.state.msgContent.tempFriendId = friendId // 正在废弃
      console.log("-----userInfo2-----", friendInfo);
      let nFriendInfo = {
        groupId: friendInfo.groupId,
        groupName: friendInfo.groupName,
        msg: friendInfo.msg,
        unreadMessages: friendInfo.unreadMessages,
        friendAvatar: friendInfo.friendAvatar,
        type: 1, // 0单聊，1群聊
      };
      this.$store.state.msgContent.tempGroupInfo = nFriendInfo;

      let myId = this.my.id;

      console.log("tochat friend", groupId, myId);
      // 获取与当前好友聊天内容列表
      // this.getMessageList(friend)

      let msgList = this.$store.state.msgContent["g" + groupId];
      if (undefined == msgList || msgList.length == 0) {
        this.initGroupMsg({
          groupId: groupId,
          myId,
          callback: (data) => {
            this.refreshMessageList(data);
          },
        });
      } else {
        this.messageList = msgList;
        // this.$store.state.msgContent['g' + groupId] = msgList
      }

      // 将所有聊天记录置为已读，若消息列表为空，则不必执行此操作，后台处理
      setGroupMessageReaded({
        groupId: groupId,
        userId: myId,
        readMsgId: 0, // 随便填
      });

      this.$store.state.msgContent.group.forEach((item) => {
        if (item.groupId == groupId) {
          item.unreadMessages = 0;
        }
      });
      let that = this;
      setTimeout(function () {
        var div = document.getElementById("magBox");
        div.scrollTop = div.scrollHeight;
        that.calMagBoxHeight();
      }, 50);
    },
    refreshMessageList(data) {
      console.log(
        "-=-=-=refreshMessageList",
        data,
        this.$store.state.msgContent.tempGroupInfo.groupId
      );
      console.log(this.$store);

      // 如果你需要在 store 中动态添加新属性，可以使用 Vue.set 方法。这样可以确保新属性也是响应式的。
      this.$store.dispatch("updateMsgProfile", {
        key: "g" + this.$store.state.msgContent.tempGroupInfo.groupId,
        value: data,
      });

      // this.$store.state.msgContent[this.$store.state.msgContent.tempGroupInfo.friendId] = data
      this.messageList = data;
    },
    tochatbak() {
      var that = this;
      that.$router.push({
        name: "mychat",
        params: {
          refresh: true,
        },
      });
    },
    getMessageList(friend) {
      console.log("--getMessageList--");
      var that = this;
      getGroupMessageFromLast({
        groupId: friend.groupId,
        myId: this.my.id,
        start: 0,
      })
        .then((response) => {
          console.log(response.data);
          that.$store.state.msgContent[
            "g" + that.$store.state.msgContent.tempGroupInfo.groupId
          ] = response.data;
          that.messageList = response.data; // 使用搜索结果更新列表
        })
        .catch((error) => {
          console.error("搜索消息出错:", error);
        });
    },
    getChatList() {
      var that = this;
      getTmpGroupList({
        userId: this.my.id,
      })
        .then((response) => {
          console.log("getTmpGroupList", response.rows);
          // that.friList = response.rows; // 使用搜索结果更新列表

          that.$store.state.msgContent.group = response.rows;
        })
        .catch((error) => {
          console.error("搜索好友出错:", error);
        });
    },
    infiniteHandler($state) {
      var that = this;
      getMoreGroupHistory((errMag) => {
        if (errMag == null || errMag == "") {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
      console.log("刷新");
    },
  },
};
</script>

<style>
.mymsg_friend_msg {
  display: block;
  color: #999999;
  font-size: 18px;
  margin-top: 2px;
}

.mymsg_item_right {
  margin-left: 14px;
}

.mymsg_item {
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  border-bottom: solid 1px #cccccc;
}

.mymsg_friend_name {
  color: #333333;
  font-size: 18px;
}

.mymsg_fri_img {
  width: 52px;
  height: 52px;
  border-radius: 50%;
}

.mymsg_con {
  margin-top: 30px;
  background-color: white;
}

.me_msg_btn {
  color: #ffffff;
  font-size: 14px;
  margin-left: 15px;
  font-weight: 550;
  cursor: pointer;
}

.mymsg_sear_ops_con {
  display: flex;
  align-items: center;
}

.mymsg_start_col_btn {
  background-image: url("../assets/btnbg.png");
  width: 99px;
  height: 30px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: white;
  border: none;
  cursor: pointer;
}

.friend_add_in {
  margin-left: 5px;
  background: none;
  font-size: 18px;
  border: none;
  outline: none;
}

.friend_add_in_con {
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  border: solid 2px #0187ea;
  background-color: #edf7f9;
  width: 450px;
}

.mymsg_sear_con {
  display: flex;
  align-items: center;
}

.mymsg_sear {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mymsg_tip_noac {
  color: #707070 !important;
}

.mymsg_tip {
  font-size: 18px;
  color: #2683be;
  cursor: pointer;
}

.mymsg_top_bar {
  display: flex;
  align-items: center;
  height: 30px;
}

.chat_in:focus {
  outline: none;
}

.chat_in {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /*Firefox*/
  -webkit-box-sizing: border-box;
  /*Safari*/
  font-size: 16px;
  height: 80px;
  border: none;
}

.magBox {
  overflow-y: scroll;
  max-height: 400px;
}
.groupBox {
  overflow-y: scroll;
  max-height: 800px;
}
</style>
